import React from 'react'
import PageHeader from '../../../Components/UI/PageHeader'
import VisitsDataTable from '../../../Components/sb/visits/visitsIndex'

const Visits = () => {
  return (
    <div>  
        <PageHeader title="Visits" />
        <VisitsDataTable/>
    </div>
  )
}

export default Visits